import React, { memo } from 'react'

const AudioIcon: React.FC = memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="currentColor"
  >
    <path
      d="M7.2 14.4C7.95 14.4 8.5875 14.1375 9.1125 13.6125C9.6375 13.0875 9.9 12.45 9.9 11.7V5.4H11.7C11.955 5.4 12.1688 5.31375 12.3413 5.14125C12.5138 4.96875 12.6 4.755 12.6 4.5C12.6 4.245 12.5138 4.03125 12.3413 3.85875C12.1688 3.68625 11.955 3.6 11.7 3.6H9.45C9.195 3.6 8.98125 3.68625 8.80875 3.85875C8.63625 4.03125 8.55 4.245 8.55 4.5V9.36C8.34 9.24 8.1225 9.15 7.8975 9.09C7.6725 9.03 7.44 9 7.2 9C6.45 9 5.8125 9.2625 5.2875 9.7875C4.7625 10.3125 4.5 10.95 4.5 11.7C4.5 12.45 4.7625 13.0875 5.2875 13.6125C5.8125 14.1375 6.45 14.4 7.2 14.4ZM9 18C7.755 18 6.585 17.7637 5.49 17.2912C4.395 16.8187 3.4425 16.1775 2.6325 15.3675C1.8225 14.5575 1.18125 13.605 0.70875 12.51C0.23625 11.415 0 10.245 0 9C0 7.755 0.23625 6.585 0.70875 5.49C1.18125 4.395 1.8225 3.4425 2.6325 2.6325C3.4425 1.8225 4.395 1.18125 5.49 0.70875C6.585 0.23625 7.755 0 9 0C10.245 0 11.415 0.23625 12.51 0.70875C13.605 1.18125 14.5575 1.8225 15.3675 2.6325C16.1775 3.4425 16.8187 4.395 17.2912 5.49C17.7637 6.585 18 7.755 18 9C18 10.245 17.7637 11.415 17.2912 12.51C16.8187 13.605 16.1775 14.5575 15.3675 15.3675C14.5575 16.1775 13.605 16.8187 12.51 17.2912C11.415 17.7637 10.245 18 9 18Z"
      fill="currentColor"
    />
  </svg>
))

export { AudioIcon }
